// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"561":"cf3571eb0c89b3c9","884":"8a281129cfb0fb9f","923":"3923a8f21d4bee65"}[chunkId] + ".js";
};